export enum AppErrorType {
  INVALID_SESSION = 'Invalid-Session',
  UnauthorizedOpportunityAccessError = 'UnauthorizedOpportunityAccessError',
  SapError = 'SapError',
  Forbidden = 'Forbidden',
  NotFound = 'NotFound',
  VersionMismatch = 'VersionMismatch',
  SalesforceError = 'SalesforceError',
  SalesforcePermissionError = 'SalesforcePermissionError',
  TimeoutError = 'TimeoutError',
  CacheExpired = 'CacheExpired',
  ValidationError = 'ValidationError',
  DatabaseError = 'DatabaseError',
  InternalServerError = 'InternalServerError',
  ServiceUnavailable = 'ServiceUnavailable',
  NetworkError = 'NetworkError',
  UnknownError = 'UnknownError',
  DataError = 'DataError',
  StorageError = 'StorageError',
  Unhandledrejection = 'Unhandledrejection',
  GendocError = 'GendocError'
}

export class ApiError extends Error {
  public readonly type: AppErrorType

  public readonly status?: number

  public readonly timestamp?: string

  public readonly clientReqId?: string

  public readonly cause?: Error | string

  constructor(
    type: AppErrorType,
    message: string,
    status?: number,
    name?: string,
    cause?: Error | string,
    clientReqId?: string
  ) {
    super(message)
    this.name = name || 'ApiError'
    this.type = type
    this.status = status
    this.timestamp = new Date().toISOString()
    this.cause = cause
    this.clientReqId = clientReqId

    // Error.message is set as non-enumerable by super(), so JSON.stringify silently drops it.
    // Redefine as enumerable so SSE serialization preserves it.
    Object.defineProperty(this, 'message', { value: message, enumerable: true, writable: true, configurable: true })

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError.prototype.constructor)
    }

    // captureStackTrace installs a lazy non-enumerable getter for `stack`.
    // Read it now (forces evaluation) then redefine as enumerable.
    const stackValue = this.stack
    Object.defineProperty(this, 'stack', { value: stackValue, enumerable: true, writable: true, configurable: true })

    Object.setPrototypeOf(this, ApiError.prototype)
  }
}

export const getUnhandledError = (errorMessage: string): ApiError =>
  new ApiError(AppErrorType.Unhandledrejection, errorMessage)
